import { css, cx } from '@emotion/css';
import MultilineText from '../../utils/MultilineText';

const Description = ({ text }: { text?: string | null }) => {
    if (!text) {
        return (
            <div
                className={css`
                    margin-bottom: 24px;
                `}
            />
        );
    }

    return (
        <div
            className={cx(
                'uxsignals-description',
                css`
                    margin-top: 8px;
                    margin-bottom: 24px;
                    display: flex;
                    gap: 12px;
                    flex-direction: column;
                `,
            )}
        >
            <MultilineText text={text} />
        </div>
    );
};

export default Description;
